import React, { useEffect,useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import { Backdrop } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: "relative",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  }));
  const baseUrl = process.env.REACT_APP_REPORT_API_URL;
  
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export const VisualizadorRemitoMesaEntrada = ({ abrirModal, setAbrirModal, reporte }) => {
    const classes = useStyles();
    const [openSpinner, setOpenSpinner] = React.useState(true);
    const [urlreport, setUrlreport] = useState('');
    useEffect (() => {
      if(abrirModal)
        setOpenSpinner(true);
        if(reporte === 'remito'){
          setUrlreport(`${ baseUrl }/Reportes/ViewReportMesaEntadaRemito`);
        }
    }, [abrirModal,reporte]);
    
    const handleClose = () => {
      setAbrirModal(false);
    };
    const handleLoad = () => {
      setOpenSpinner(false);
    }
    return (
      <div>
        <Dialog
          fullScreen
          open={abrirModal}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
              {'Remito Mesa Entrada'} 
              </Typography>
              <Button
                autoFocus
                color="inherit"
                onClick={(e) => {
                  handleClose(e);
                }}
              >
                Cerrar
              </Button>
            </Toolbar>
          </AppBar>
          <Backdrop className={classes.backdrop} open={openSpinner}>
            <Typography variant="h1" component="h2">
              Aguarde...
            </Typography>
            <CircularProgress color="inherit" />
          </Backdrop>
          <div>          
            <iframe 
              title="Reportes" 
              src={urlreport} 
              style={{height: `100vh`,width: `100vw`}}
              onLoad={handleLoad}
            />
          </div>
        </Dialog>
      </div>
    );
  };
  